import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {RoleAddComponent} from 'src/app/modules/settings/roles/role-add/role-add.component';
import {FieldConfig} from 'src/app/shared/components/dynamic-forms-components/field.interface';
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {
  title: string;
  fields: FieldConfig[];
  feedBackForm: FormGroup;
  hide: boolean = false;
  hide1: boolean = false;
  feedbackCategories = [
    { name: 'complain', value: 'complain'},
    { name: 'suggestion', value: 'suggestion'},
    { name: 'inquiry', value: 'inquiry'},
    { name: 'complement', value: 'complement'}
  ]
  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<RoleAddComponent>,

  ) { }


    ngOnInit(): void {
      this.feedBackForm = this.fb.group({
        fullname: [null, ],
        Phonenumber: [null, ],
        Email: [null, ],
        Comment: [null, ]
      })
    }

    closeModal(close: boolean): void {
      if (close) {
        this.dialogRef.close();
      }
    }

}
